exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.md-list[data-v-0ac2082c]{width:320px;max-width:100%;display:inline-block;vertical-align:top;border:1px solid rgba(0,0,0,0.12)\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/views/integration/list-integrator.vue"],"names":[],"mappings":";AAAA,0BAAS,YAAY,eAAe,qBAAqB,mBAAmB,iCAAiC;CAAC","file":"list-integrator.vue","sourcesContent":[".md-list{width:320px;max-width:100%;display:inline-block;vertical-align:top;border:1px solid rgba(0,0,0,0.12)}\n"],"sourceRoot":""}]);

// exports
